import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { kpisMock } from './mock';

const Stat = ({ label, value, suffix }) => (
  <Card variant="outlined">
    <CardContent>
      <Typography variant="overline" color="text.secondary">{label}</Typography>
      <Typography variant="h5" fontWeight={700}>{value}{suffix || ''}</Typography>
    </CardContent>
  </Card>
);

export default function Dashboard() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={3}><Stat label="Ocupação Hoje" value={kpisMock.ocupacaoHoje} suffix="%" /></Grid>
      <Grid item xs={6} md={3}><Stat label="RevPAR" value={kpisMock.revpar.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} /></Grid>
      <Grid item xs={6} md={3}><Stat label="ADR" value={kpisMock.adr.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} /></Grid>
      <Grid item xs={6} md={3}><Stat label="Reservas Pendentes" value={kpisMock.reservasPendentes} /></Grid>
    </Grid>
  );
}
